export default __webpack_public_path__ + "static/media/Group-216.eb4bef67.svg";